export { default as SpinningButton } from './component'
